import { QueryClient } from '@tanstack/react-query';

import { SIX_HOURS_IN_MILLISECONDS } from '@/constants/common';
import { useGetMagazineRelatedMagazinesQuery } from '@/hooks/magazine/magazine.gql.impl';
import { parseRelatedMagazines } from '@/parsers/Communication/magazine';

const useGetRelatedMagazine = (magazinePid: string) => {
  const { data: relatedMagazine = [] } = useGetMagazineRelatedMagazinesQuery(
    {
      request: {
        size: 4,
        magazinePid,
      },
    },
    {
      select: parseRelatedMagazines,
      staleTime: SIX_HOURS_IN_MILLISECONDS,
      cacheTime: SIX_HOURS_IN_MILLISECONDS,
    },
  );
  return {
    relatedMagazine,
  };
};

export default useGetRelatedMagazine;

useGetRelatedMagazine.getKey = (magazinePid: string) => {
  return useGetMagazineRelatedMagazinesQuery.getKey({
    request: {
      size: 4,
      magazinePid,
    },
  });
};

useGetRelatedMagazine.prefetchQuery = async (queryClient: QueryClient, magazinePid: string) => {
  await queryClient.prefetchQuery(
    useGetMagazineRelatedMagazinesQuery.getKey({
      request: {
        magazinePid,
        size: 4,
      },
    }),
    useGetMagazineRelatedMagazinesQuery.fetcher({
      request: {
        magazinePid,
        size: 4,
      },
    }),
  );
};
